export const environment = {
  production: true,
  apiUrl: "https://account-dev.chapps.com/",
  environmentName: "Dev"
};
